import './Modal.sass'
import Modal from './Modal'

export default Modal
